const SCROLL_ANIMATION_TRIGGER_CLASSNAME = "scroll-trigger";
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = "scroll-trigger--offscreen";
const SCROLL_ANIMATION_CANCEL_CLASSNAME = "scroll-trigger--cancel";

// Safety-net delay: if an element never gets revealed by the
// IntersectionObserver below (a conflicting app script, a slow
// connection, a timing issue after pagination/filtering, etc.), force it
// to appear anyway after this many milliseconds instead of leaving it
// invisible forever. This does NOT affect real image loading (that is
// still handled separately by the browser's native lazy-loading) - it
// only guarantees the fade-in wrapper never gets stuck hidden.
const SCROLL_ANIMATION_SAFETY_NET_DELAY_MS = 2500;

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (
        elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)
      ) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute("data-cascade"))
          elementTarget.setAttribute("style", `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(
  rootEl = document,
  isDesignModeEvent = false,
) {
  const animationTriggerElements = Array.from(
    rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME),
  );
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add("scroll-trigger--design-mode");
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: "0px 0px -50px 0px",
  });
  animationTriggerElements.forEach((element) => observer.observe(element));

  // --- SAFETY NET (new) --------------------------------------------------
  // Guarantee that nothing stays permanently invisible even if the
  // IntersectionObserver above never fires for a given element.
  window.setTimeout(() => {
    animationTriggerElements.forEach((element) => {
      if (element.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        element.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        observer.unobserve(element);
      }
    });
  }, SCROLL_ANIMATION_SAFETY_NET_DELAY_MS);
  // ------------------------------------------------------------------------
}

// Expose this globally and explicitly so other theme/app scripts (e.g.
// facets.js, used for AJAX filtering/sorting) can reliably call it after
// they swap in new product grid content.
window.initializeScrollAnimationTrigger = initializeScrollAnimationTrigger;

window.addEventListener("DOMContentLoaded", () => {
  initializeScrollAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", (event) =>
    initializeScrollAnimationTrigger(event.target, true),
  );
  document.addEventListener("shopify:section:reorder", () =>
    initializeScrollAnimationTrigger(document, true),
  );
}